var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcChromeActive = function SvgIcChromeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-chrome-active_svg__ic-chrome-active",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M3.863 5.574c7.438-8.657 21.23-6.947 26.386 3.164H17.858c-2.233 0-3.673-.05-5.235.772-1.835.966-3.22 2.757-3.703 4.86L3.863 5.573v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M10.677 16c0 2.933 2.386 5.32 5.318 5.32 2.932 0 5.317-2.387 5.317-5.32 0-2.934-2.385-5.321-5.317-5.321-2.932 0-5.318 2.386-5.318 5.32V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M18.059 22.964c-2.985.887-6.478-.097-8.392-3.4-1.46-2.52-5.318-9.243-7.072-12.3C-3.548 16.68 1.747 29.51 12.897 31.7l5.162-8.735v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M20.934 10.679c2.487 2.312 3.028 6.056 1.344 8.959-1.269 2.187-5.318 9.02-7.28 12.33 11.489.709 19.865-10.552 16.082-21.29H20.933h.001z"
  }))));
};
export default SvgIcChromeActive;